import { Component } from '@angular/core';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
})
export class FaqComponent {
  data: any = [
    {
      parentName: 'faq1',
      childProperties: [
        {
          propertyName: 'faq_para1',
          links: [''],
        },
      ],
    },
    {
      parentName: 'faq2',
      childProperties: [{
        propertyName: 'faq_para2',
        links: ['']
      }],
    },
    {
      parentName: 'faq3',
      childProperties: [{
        propertyName: 'faq_para3',
        links: ['']
      }],
    },
    {
      parentName: 'faq4',
      childProperties: [
        {
          propertyName: 'faq_para4',
          links: ['http://bestwallet.com/airdrop'],
        },
      ],
    },
    {
      parentName: 'faq5',
      childProperties: [
        {
          propertyName: 'faq_para5',
          links: ['https://linktr.ee/bestweb3official'],
        },
      ],
    },
    {
      parentName: 'faq6',
      childProperties: [{
        propertyName: 'faq_para6',
        links: ['']
      }],
    },

    {
      parentName: 'faq7',
      childProperties: [{
        propertyName: 'faq_para7',
        links: ['']
      }],
    },
    {
      parentName: 'faq8',
      childProperties: [{
        propertyName: 'faq_para8',
        links: ['']
      }],
    },
    {
      parentName: 'faq9',
      childProperties: [{
        propertyName: 'faq_para9',
        links: ['']
      }],
    },
  ];
  options: AnimationOptions = {
    path: '/assets/lottie/nextgen-avtar.json',
  };
  onAnimate(animationItem: AnimationItem): void {
    console.log(animationItem);
  }
  styles: Partial<CSSStyleDeclaration> = {
    width: '224px',
    height: '224px',
    margin: '0 auto',
    scale: '1.8',
  };

  // toggleAccordian(event: any, index: any) {
  //   const element = event.target;
  //   element.classList.toggle('active');
  //   if (this.data[index].isActive) {
  //     this.data[index].isActive = false;
  //   } else {
  //     this.data[index].isActive = true;
  //   }
  //   const panel = element.nextElementSibling;
  //   if (panel.style.maxHeight) {
  //     panel.style.maxHeight = null;
  //   } else {
  //     panel.style.maxHeight = panel.scrollHeight + 'px';
  //   }
  // }

  toggleAccordian(event: any, index: any) {
    const element: HTMLElement = event.target;
    const panel: HTMLElement | null = element.nextElementSibling as HTMLElement | null;
    // Close previously open accordions
    this.data.forEach((item: any, i: number) => {
      if (i !== index && item.isActive) {
        item.isActive = false;
        const prevPanel: HTMLElement | null = document.querySelectorAll('.panel')[i] as HTMLElement | null;
        if (prevPanel) {
          prevPanel.style.maxHeight = ""; // Set to empty string
        }
        const prevElement: HTMLElement | null = document.querySelectorAll('.accordion')[i] as HTMLElement | null;
        if (prevElement) {
          prevElement.classList.remove('active');
        }
      }
    });
    // Toggle the clicked accordion
    element.classList.toggle('active');
    this.data[index].isActive = !this.data[index].isActive;
    if (panel) {
      if (panel.style.maxHeight) {
        panel.style.maxHeight = ""; // Set to empty string
      } else {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    }
  }
}
